export default __webpack_public_path__ + "static/media/3-bm.750aac38.webp";